// Author YuJiaBei
// Date 2020-08-10 09:06:39

import * as model from "@/model/em/maintenance/EmMaMaintenanceCatModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmMaMaintenanceCat(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_MAINTENANCE_URL,
    })
    .buildStore()
